function flattenError(error) {
    const values = [
        error?.reason,
        error?.shortMessage,
        error?.message,
        error?.error?.reason,
        error?.error?.message,
        error?.data?.message,
    ]
    return values.filter(Boolean).join(' | ').toLowerCase()
}
export function getLocalizedWalletError(error, t) {
    const code = error?.code ?? error?.error?.code
    const message = flattenError(error)

    if (
        code === 4001 ||
        code === 'ACTION_REJECTED' ||
        message.includes('user rejected') ||
        message.includes('user denied') ||
        message.includes('denied transaction signature')
    ) {
        return t('用户已取消钱包操作')
    }
    if (message.includes('insufficient funds') || message.includes('insufficient balance')) {
        return t('钱包余额不足，无法支付本次交易和 Gas 费用')
    }
    if (message.includes('chain mismatch') || message.includes('wrong network') || message.includes('network mismatch')) {
        return t('当前钱包网络与项目网络不一致')
    }
    if (message.includes('wallet not connected')) return t('请先连接钱包再操作')
    if (
        message.includes('wallet is not token owner') ||
        message.includes('caller is not token owner') ||
        message.includes('transfercallernotownernorapproved') ||
        message.includes('transfer from incorrect owner')
    ) {
        return t('当前钱包不是该 NFT 的持有人')
    }
    if (message.includes('non erc721receiver') || message.includes('erc721receiver')) {
        return t('接收地址无法接收 NFT')
    }
    if (message.includes('not fee')) return t('手续费不足')
    if (message.includes('ownable: caller is not the owner') || message.includes('018001')) return t('权限不足')
    if (message.includes('too much')) return t('铸造总量已达到上限')
    if (message.includes('nft : limit')) return t('您的铸造数量已达上限')
    if (message.includes('not wl')) return t('您的邀请者还未铸造NFT')
    if (message.includes('inviter == msg')) return t('您不能邀请自己参与铸造')
    if (message.includes('inviter cycle')) return t('邀请关系存在循环，无法绑定')
    if (message.includes('inviter chain too deep')) return t('邀请层级过深，无法继续绑定')
    if (message.includes('stale config')) return t('铸造配置已更新，请确认新价格后重试')
    if (message.includes('inexact incoming transfer') || message.includes('inexact outgoing transfer')) {
        return t('支付代币存在转账税或余额变化异常，请确认 NFT 合约已双向免税')
    }
    return t('交易提交失败，请稍后重试')
}
